<template>
  <div>
    <div class="background"></div>
    <div class="main">
      <div class="main-left">
        <div ref="objects" class="objects"></div>
        <div class="cents-container">
          <div ref="cents" class="cents"></div>
        </div>
      </div>
    </div>
    <div class="qr">
      <p>Fill out the form on your phone!</p>
      <img src="@/assets/qr.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Main",
  props: {},
  mounted() {
    setTimeout(() => {
      this.$refs.objects.style.backgroundImage =
        `url(` + require("../assets/objects.png") + ")";
      this.$refs.objects.className += " fade-in";
    }, 800);

    setTimeout(() => {
      this.$refs.cents.style.backgroundImage =
        `url(` + require("../assets/96-cents.png") + ")";
      this.$refs.cents.className += " fade-in";
      setTimeout(() => {
        this.$refs.cents.className += " breathe";
      }, 2500);
    }, 2000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qr {
  position: absolute;
  bottom: 0px;
  padding: 50px 100px;
  right: 150px;
  display: flex;
  align-items: center;
}

.qr p {
  color: white;
  font-size: 30px;
  font-weight: 500;
  max-width: 300px;
  text-align: right;
}

.qr img {
  height: 250px;
  margin-left: 50px;
}
</style>
